import React from "react";
import themePropTypes from "../theme-prop-types";

const Dot = ({ name }) => (
  <span className='dot-web-sdk' data-testid={`dot-${name}`} />
);

Dot.propTypes = themePropTypes.dot;

export default Dot;
